import { TicketingIntegration } from 'shared/types';
import CreateJiraTicketDialog from '../CreateJiraTicketDialog';
import CreateLinearTicketDialog from '../CreateLinearTicketDialog';

export type CreateTicketDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (customFields?: Record<string, any>) => void;
  integration: TicketingIntegration;
  envId: string;
  isCreating: boolean;
  error?: Error | null;
  defaultFields?: Record<string, any> | null;
  isLoadingDefaults?: boolean;
  contextId?: string;
};

const CreateTicketDialog = (props: CreateTicketDialogProps) => {
  const { integration } = props;
  if (integration.type === 'jira') {
    return <CreateJiraTicketDialog {...props} />;
  }
  if (integration.type === 'linear') {
    return <CreateLinearTicketDialog {...props} />;
  }
  return null;
};

export default CreateTicketDialog;
